<template>
    <div class="BBSDetailDiv">
        <label class="BBSDetailTitle">{{ BBSDetailData.title }}</label>
        <div class="ContentInfoDiv">
            <img src="@/assets/svg/icon_author.svg" class="ContentInfoIcnoAuthor">
            <label class="ContentInfoText">{{ BBSDetailData.owner.username }}</label>
            <img src="@/assets/svg/icon_huifu.svg" class="ContentInfoIcnoComment">
            <label class="ContentInfoText">{{ BBSDetailData.ascount }} {{ i18n.$t('BBSQASearchAnswerCount') }}</label>
            <img src="@/assets/svg/icon_time.svg" class="ContentInfoIcnoTime">
            <label class="ContentInfoText">{{ BBSDetailData.createTime }}</label>
        </div>
        <div class="BBSDetailContent" v-html="BBSDetailData.content"></div>
        <!-- <hr style="border:none;border-top:1px solid #D8D8D8;margin: 30px 0px;"/> -->
        <label class="BBSDetailAnswerLabel">{{ i18n.$t('BBSDetailAnswer') }}</label>
        <ul style="margin-top:10px;">
            <li :class="item.level == 0?'BBSDetailAnswerLi':'BBSDetailAnswerUpLi'" v-for="item in BBSAnswerData" :key="item.id">
                <a-avatar :size="50" style="color: #f56a00; backgroundColor: #fde3cf;margin-left:10px;" class="UserAvatar">{{ item.owner.username }}</a-avatar>
                <div class="AnswerContent" v-html="item.content"></div>
                <div class="AnswerContentInfoDiv">
                    <img src="@/assets/svg/icon_author.svg" class="ContentInfoIcnoAuthor">
                    <label class="ContentInfoText">{{ item.owner.username }}</label>
                    <img src="@/assets/svg/icon_time.svg" class="ContentInfoIcnoTime">
                    <label class="ContentInfoText">{{ item.createTime }}</label>
                </div>
                <VerticalAlignTopOutlined class="UpToTop" v-if="item.level == 0 && Group == 'ROLE_developer'" @click="TopAnswer(item.id)"/>
                <VerticalAlignBottomOutlined style="color:red;" class="UpToTop" v-if="item.level >0 && Group == 'ROLE_developer'" @click="CancelTopAnswer(item.id)"/>
            </li>
        </ul>
        <div style="text-align: center;">
            <a-pagination
                style="margin-right:35px;padding:15px 0px;"
                :current="currentPage"
                :pageSize="pageSize"
                :total="Total"
                @change="changePage"
            />
        </div>
        <div v-if="isLogin">
            <label class="BBSDetailAnswerLabel">{{ i18n.$t('BBSDetailAnswerQ') }}</label><br>
            <a-avatar :size="50" style="color: #f56a00; backgroundColor: #fde3cf;" class="UserAvatar">{{username}}</a-avatar>
            <tinymce-editor
                ref="editor"
                :tinymceHeight = 300
                class="BBSAnswerContent"
                v-model="BBSAnswerContent"
                :value="BBSAnswerContent"
                @input="handleInput"
            >
            </tinymce-editor>
            <div class="BBSEditButtonDiv">
                <img class="BBSEditButton" @click="AddBBSAnswer()" src="@/assets/svg/botton_发表.svg">
            </div>
        </div>
    </div>
</template>
<script>
import { useI18n } from "@/i18nPlugin";
import { defineComponent, ref } from "vue";
import TinymceEditor from "@/components/tinymce-editor/tinymce-editor";
import { useRouter } from 'vue-router';
import {     
    SearchBBSDetailData,
    SearchBBSAnswerData,
    AddBBSAnswerData,
    TopBBSAnswerData,
    CancelBBSAnswerData
} from '../api/index';
export default defineComponent({
    components: {
        TinymceEditor,
    },
    setup() {
        const i18n = useI18n();
        const router = useRouter();
        const currentPage = ref(1);
        const Group = localStorage.getItem("Group");
        const pageSize = ref(10);
        const Total = ref(0);
        // const { ctx } = getCurrentInstance()
        const token = localStorage.getItem("userToken");
        const username = localStorage.getItem("userName_ats");
        const isLogin = localStorage.getItem("isLogin");
        const  getQueryVariable = (variable) =>{
            var query = window.location.search.substring(1);
            var vars = query.split("&");
            for (var i=0;i<vars.length;i++) {
                    var pair = vars[i].split("=");
                    if(pair[0] == variable){return pair[1];}
            }
            return(false);
        }
        const BBSDetailData = ref({
            ascount: 0,
            content: "",
            createTime: "",
            owner: {
                username: "",
            },
            title: ""
        });
        const BBSAnswerData = ref([
            {
                owner: {
                    username: "",
                },
                content: "",
                createTime: ""
            }
        ]);
        const BBSAnswerContent = ref("");
        const handleInput = (value) => {
            BBSAnswerContent.value = value;
            // console.log(value);
        };
        const SearchBBSDetail = () => {
            const BBSid = getQueryVariable("id");
            SearchBBSDetailData ({
                id: BBSid
            }).then(res => {
                BBSDetailData.value = res.data;
                // console.log(res)
            }).catch(error => {
                console.log(error)
            });
        }
        const SearchBBSAnswer = (pageSize,currentPage) => {
            const BBSid = getQueryVariable("id");
            SearchBBSAnswerData ({
                placardId: BBSid,
                pageSize: pageSize,
                currentPage: currentPage
            }).then(res => {
                Total.value = res.total;
                BBSAnswerData.value = res.data;
                // console.log(res)
            }).catch(error => {
                console.log(error)
            });
        }
        const changePage = (page, pageSize) => {
            // console.log('page', page);
            currentPage.value = page
            // console.log('pageSize', pageSize);
            SearchBBSAnswer(pageSize,page);
        };
        const AddBBSAnswer = () => {
            const BBSid = getQueryVariable("id");
            AddBBSAnswerData ({
                placardId: BBSid,
                content: BBSAnswerContent._rawValue
            },token).then(res => {
                SearchBBSAnswer();
                history.go(0)
                // console.log(res)
            }).catch(error => {
                console.log(error)
            });
        }
        const TopAnswer = (id) => {
            TopBBSAnswerData ({
                id: id,
            },token).then(res => {
                // console.log(res)
                SearchBBSAnswer(pageSize.value,1);
            }).catch(error => {
                console.log(error)
            });
        }
        const CancelTopAnswer = (id) => {
            CancelBBSAnswerData ({
                id: id,
            },token).then(res => {
                // console.log(res)
                SearchBBSAnswer(pageSize.value,1);
            }).catch(error => {
                console.log(error)
            });
        }
        return {
            i18n,
            token,
            Group,
            currentPage,
            pageSize,
            Total,
            changePage,
            router,
            username,
            isLogin,
            BBSDetailData,
            BBSAnswerData,
            BBSAnswerContent,
            handleInput,
            SearchBBSDetail,
            SearchBBSAnswer,
            AddBBSAnswer,
            TopAnswer,
            CancelTopAnswer
        }
    },
    mounted() {
        this.SearchBBSDetail();
        this.SearchBBSAnswer(this.pageSize,this.currentPage);
    }
})
</script>

<style lang="less" scoped>
    p,ul,li {
        margin: 0px;
        padding: 0px;
    }
    .BBSDetailDiv {
        padding: 30px 50px;
        text-align: left;
        .BBSDetailTitle {
            font-size: 32px;
        }
        .BBSDetailContent {
            margin-top: 30px;
            width: 100%;
            padding-bottom: 20px;
        }
        .AnswerContentInfoDiv {
            margin-top: 10px;
            margin-left: 80px;
            font-size: 12px;
            color: #BBBBBB;
        }
        .ContentInfoDiv {
            margin-top: 17px;
            font-size: 12px;
            color: #BBBBBB;
        }
        .ContentInfoIcnoComment {
            width: 11px;
            height: 12px;
            margin-left: 14px;
            margin-right: 7px;
            display: inline-block;
        }
        .ContentInfoIcnoTime {
            width: 12px;
            height: 12px;
            margin: 0 8px;
            display: inline-block;
        }
        .ContentInfoIcnoAuthor {
            width: 13.8px;
            height: 12px;
            margin-right: 6.2px;
            display: inline-block;
        }
        .ContentInfoText {
            font-size: 12px;
            line-height: 12px;
            color: #BBBBBB;
        }
        .UpToTop {
            cursor: pointer;
            float: right;
            margin-top: -20px;
            margin-right: 20px;
        }
        .BBSDetailAnswerLabel {
            margin-top: 15px;
            font-size: 20px;
            font-weight: bold;
            color: rgb(255, 174, 0);
        }
        .BBSDetailAnswerLi {
            border-radius: 2px;
            border-radius: 2px;
            padding: 10px 0px;
            text-align: left;
            list-style: none;
            margin-top: -1px;
            border: 1px solid #D8D8D8;
        }
        .BBSDetailAnswerUpLi {
            border-radius: 2px;
            border-radius: 2px;
            padding: 10px 0px;
            text-align: left;
            list-style: none;
            margin-top: -1px;
            border-top: 1px solid #D8D8D8;
            border-bottom: 1px solid #D8D8D8;
            border-left: 5px solid #db5000;
            border-right: 5px solid #db5000;
        }
        .LoadingDiv {
            cursor: pointer;
            width: 1020px;
            height: 40px;
            text-align: center;
            margin: 10px 0px;
            background: #F5F5F5;
            border: 1px solid #D7D7D7;
        }
        .LoadingLabel {
            cursor: pointer;
            font-size: 14px;
            line-height: 40px;
            color: #606266;
        }
        .AnswerContent {
            display: inline-block;
            width: 850px;
            margin-left: 80px;
            margin-top: 20px;
        }
        .UserAvatar {
            position: absolute;
            margin: 10px 30px 0 0px;
        }
        .BBSAnswerContent {
            display: inline-block;
            margin-top: 10px;
            margin-left: 70px;
        }
        .BBSEditButtonDiv {
            margin-top: 20px;
        }
        .BBSEditButton {
            cursor: pointer;
            width: 125px;
            height: 35px;
            margin-right: 88px;
            margin-bottom: 20px;
            float: right;
        }
    }
</style>